/**
 * Provides typed abstraction for Angular FormGroup
 *
 * @export
 * @class SearchForm
 * @template TForm
 */
var SearchForm = /** @class */ (function () {
    /**
     * Creates an instance of SearchForm.
     * @param {FormGroup} form
     * @memberof SearchForm
     */
    function SearchForm(form) {
        this.form = form;
    }
    /**
     * Converts 'value' to string
     *
     * @private
     * @param {*} value
     * @returns {string}
     * @memberof SearchForm
     */
    SearchForm.stringify = function (value) {
        if (value instanceof Date) {
            return value.toISOString();
        }
        if (typeof value === 'boolean') {
            return value ? '1' : '';
        }
        return String(value);
    };
    Object.defineProperty(SearchForm.prototype, "formGroup", {
        /**
         * FormGroup instance
         *
         * @readonly
         * @type {FormGroup}
         * @memberof SearchForm
         */
        get: function () {
            return this.form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchForm.prototype, "valid", {
        /**
         * valid property of the FormGroup
         *
         * @readonly
         * @type {boolean}
         * @memberof SearchForm
         */
        get: function () {
            return this.form.valid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchForm.prototype, "dirty", {
        /**
         * dirty property of the FormGroup
         *
         * @readonly
         * @type {boolean}
         * @memberof SearchForm
         */
        get: function () {
            return this.form.dirty;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the AbstractControl of the field
     *
     * @param {keyof TForm} field
     * @returns {AbstractControl}
     * @memberof SearchForm
     */
    SearchForm.prototype.get = function (field) {
        var element = this.form.get(String(field));
        if (element === undefined) {
            throw new Error('Field ' + String(field) + ' is not defined on SearchForm');
        }
        return element;
    };
    /**
     * Sets the value of the field
     *
     * @param {keyof TForm} field
     * @param {(string | number | Date | boolean)} value
     * @memberof SearchForm
     */
    SearchForm.prototype.setValue = function (field, value) {
        this.get(field).setValue(SearchForm.stringify(value));
    };
    /**
     * Patches the value of the field
     *
     * @param {keyof TForm} field
     * @param {(string | number | Date | boolean)} value
     * @memberof SearchForm
     */
    SearchForm.prototype.patchValue = function (field, value) {
        this.get(field).patchValue(SearchForm.stringify(value));
    };
    /**
     * Returns the value of the field (always a string)
     *
     * @param {keyof TForm} field
     * @returns {string}
     * @memberof SearchForm
     */
    SearchForm.prototype.getValue = function (field) {
        return this.get(field).value;
    };
    /**
     * Enable a field
     *
     * @param {keyof TForm} field
     * @memberof SearchForm
     */
    SearchForm.prototype.enable = function (field) {
        this.get(field).enable();
    };
    /**
     * Disable a field
     *
     * @param {keyof TForm} field
     * @memberof SearchForm
     */
    SearchForm.prototype.disable = function (field) {
        this.get(field).disable();
    };
    return SearchForm;
}());
export { SearchForm };
